import styles from "./index.module.scss";

function View({rank, point, schoolName, rankBtnHandler, setSchoolBtnHandler}) {
  return (
    <div className={styles.container}>
      <div className={styles.buttons_wrapper}>
        <div className={styles.rank_btn} onClick={setSchoolBtnHandler}>
          Tetapan Sekolah
        </div>
        <div className={styles.rank_btn} onClick={rankBtnHandler}>
          Rank Sekolah
        </div>
      </div>
      <div className={styles.rank_text}>{`#${rank} ${schoolName}`}</div>
      <div className={styles.rank_text}>{`${point} points`}</div>
    </div>
  );
}

export default View;
